module.exports = new __parcel__URL__("info.cb04b0e0.svg").toString();